import { graphql } from 'react-relay';

import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import type {
	useIsPrivacyModeEnabledQuery$data,
	useIsPrivacyModeEnabledQuery$variables,
} from './__generated__/useIsPrivacyModeEnabledQuery.graphql.ts';

export const useIsPrivacyModeEnabled = (): boolean => {
	const { cloudId, edition } = useSessionData();
	const { data, error } = useQueryInterop<
		useIsPrivacyModeEnabledQuery$data,
		useIsPrivacyModeEnabledQuery$variables
	>(
		graphql`
			query useIsPrivacyModeEnabledQuery($cloudId: ID!) {
				confluence_isPrivacyModeEnabled(cloudId: $cloudId) {
					isPrivacyModeEnabled
				}
			}
		`,
		{
			variables: {
				cloudId,
			},
			skip:
				edition !== ConfluenceEdition.PREMIUM ||
				// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
				Boolean(process.env.REACT_SSR),
		},
	);

	if (error) {
		// We dont care about the error, thus we handle it silently
		markErrorAsHandled(error);
		// Return true to avoid any privacy leakage.
		return true;
	}

	return data?.confluence_isPrivacyModeEnabled?.isPrivacyModeEnabled ?? false;
};
